import React, { useState } from 'react';
import { Menu, X, Youtube, Instagram, Facebook, Linkedin, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/Button';
const LOGO_URL = 'https://www.apc360zone.com/uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png';
const socialLinks = [{
  icon: Youtube,
  href: 'https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg',
  label: 'YouTube'
}, {
  icon: Instagram,
  href: 'https://www.instagram.com/medinatactical360/',
  label: 'Instagram'
}, {
  icon: Facebook,
  href: 'https://www.facebook.com/TeamAPCUSA/',
  label: 'Facebook'
}, {
  icon: Linkedin,
  href: 'https://www.linkedin.com/in/jose-medina-a84845a/',
  label: 'LinkedIn'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'About Us',
    href: '/about-apc'
  }, {
    name: 'Law Enforcement',
    href: '/law-enforcement-capabilities'
  }, {
    name: 'Civilian',
    href: '/civilian-protection'
  }, {
    name: 'Corporate',
    href: '/corporate-critical-incidents-planning'
  }, {
    name: 'Training',
    href: '/training'
  }, {
    name: 'Resources',
    href: '/strategic-partners'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50" data-id="element-41">
      {/* ── Utility Bar ── */}
      <div className="bg-brand-gray-900 border-b border-brand-gray-800 hidden md:block" data-id="element-42">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
          <div className="flex justify-between items-center h-9" data-id="element-44">
            <div className="flex items-center gap-4" data-id="element-45">
              <a href="tel:18666343373" className="flex items-center gap-1.5 text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-46">
                <Phone className="w-3 h-3" data-id="element-47" />
                1-866-634-3373
              </a>
              <span className="w-px h-3 bg-brand-gray-700" data-id="element-48" />
              <a href="mailto:info@apc360zone.com" className="flex items-center gap-1.5 text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-49">
                <Mail className="w-3 h-3" data-id="element-50" />
                info@apc360zone.com
              </a>
            </div>
            <div className="flex items-center gap-3" data-id="element-51">
              {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-52">
                  <social.icon className="w-3.5 h-3.5" data-id="element-53" />
                </a>)}
            </div>
          </div>
        </div>
      </div>

      {/* ── Main Nav ── */}
      <div className="bg-brand-black/90 backdrop-blur-md border-b border-brand-gray-800" data-id="element-54">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
          <div className="flex justify-between items-center h-20" data-id="element-56">
            {/* Logo */}
            <a href="/" className="flex-shrink-0 -ml-2" data-id="element-57">
              <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="h-[4.25rem] w-auto" data-id="element-58" />
            </a>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center space-x-8" data-id="element-59">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-gray-300 hover:text-brand-teal uppercase tracking-wider transition-colors" data-id="element-60">
                  {link.name}
                </a>)}
              <Button href="/Contact-Medina Tactical" variant="primary" size="sm" data-id="element-61">
                Contact Us
              </Button>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden flex items-center" data-id="element-62">
              <button onClick={() => setIsOpen(!isOpen)} className="text-brand-gray-300 hover:text-brand-white focus:outline-none" data-id="element-63">
                {isOpen ? <X className="h-6 w-6" data-id="element-64" /> : <Menu className="h-6 w-6" data-id="element-65" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Nav */}
        {isOpen && <div className="lg:hidden bg-brand-gray-900 border-b border-brand-gray-800" data-id="element-66">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-67">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-2 text-base font-medium text-brand-gray-300 hover:text-brand-teal hover:bg-brand-gray-800 uppercase tracking-wider" data-id="element-68">
                  {link.name}
                </a>)}
              <div className="px-3 py-2" data-id="element-69">
                <Button href="/Contact-Medina Tactical" variant="primary" className="w-full" data-id="element-70">
                  Contact Us
                </Button>
              </div>
              {/* Mobile social + contact */}
              <div className="px-3 pt-4 mt-2 border-t border-brand-gray-800 flex items-center justify-between" data-id="element-71">
                <div className="flex items-center gap-4" data-id="element-72">
                  {socialLinks.map(social => <a key={social.label} href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-73">
                      <social.icon className="w-4 h-4" data-id="element-74" />
                    </a>)}
                </div>
                <a href="tel:18666343373" className="text-xs text-brand-gray-400 hover:text-brand-teal transition-colors" data-id="element-75">
                  1-866-634-3373
                </a>
              </div>
            </div>
          </div>}
      </div>
    </nav>;
}